export const assetsImg = require.context('../assets', true) 